import React, { Component } from 'react';
import './DeliveryInstructions.css';
import { app } from '../../base';

let db = app.database();
let imageURL = "";
let mapsData = "";

class DeliveryInstructions extends Component {

    state = {
        addressLine: "",
        mapsData: "",
        imageURL: ""
    }

    componentDidMount() {
        db.ref('info').on('value', snap => {
            // $("#addressString").html(snap.val().addressLine);
            this.setState({
                addressLine: snap.val().addressLine,
                mapsData: "http://www.google.com/maps/place/" + snap.val().lat + "," + snap.val().lng,
                imageURL: snap.val().imageURL
            });
        });
    }

    render() {
        return (
            <div>
                <h1>Today's Deliveries</h1>
                <p id="addressString">{this.state.addressLine}</p>
                <p id="navigateBtn"><a href={this.state.mapsData}><button className="beginRoute">Begin Route</button></a></p>
                <p id="houseImage"><img src={this.state.imageURL} className="houseImg" alt="houseImg" /></p>
                {mapsData}
                <br />
                {imageURL}
            </div>
        );
    }
}

export default DeliveryInstructions;